import { cn } from "@gymflow/helpers";
import { Transition } from "@headlessui/react";
import { ReactNode } from "react";

import { Spinner } from "./Spinner";

export interface SlideSideBarProps {
  hide: () => void;
  isOpen: boolean;
  isLoading?: boolean;
  children?: ReactNode;
  className?: string;
  overlayClassName?: string;
  unmount?: boolean;
}
export function SlideSideBar({
  children,
  isOpen,
  hide,
  isLoading,
  unmount,
  className,
  overlayClassName,
}: SlideSideBarProps) {
  return (
    <>
      <div
        onClick={() => hide()}
        className={cn(
          `pointer-events-none absolute inset-0 z-[10000] backdrop-blur-[2px]`,
          { hidden: !isOpen },
          overlayClassName,
        )}
      />
      {isOpen && (
        <div
          onClick={() => hide()}
          className={cn(
            `${
              isOpen ? "opacity-10" : "pointer-events-none opacity-0"
            } bg-primary-700 absolute inset-0 z-[10001]`,
            overlayClassName,
          )}
        />
      )}
      <Transition
        className={cn(
          "absolute inset-y-0 right-0 z-[10002] w-96 !max-w-full overflow-hidden overflow-y-auto bg-gray-0 dark:bg-gray-950",
          className,
        )}
        show={isOpen}
        enter="transition-transform"
        enterFrom="translate-x-full delay-300 w-0"
        enterTo="translate-x-0"
        leave="transition-transform"
        leaveFrom="translate-x-0 delay-300 w-0"
        leaveTo="translate-x-full"
        unmount={unmount}
      >
        <div
          className={cn("absolute w-full pt-28", {
            hidden: !isLoading,
          })}
        >
          <Spinner className="!h-12 !w-12" />
        </div>
        <div
          className={cn("flex max-h-full h-full flex-col", {
            "opacity-25": isLoading,
          })}
        >
          {children}
        </div>
      </Transition>
    </>
  );
}
